/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { useSelector } from 'react-redux';
import Antechamber from './Antechamber';
import Room from './Room';
import EmotionReport from './EmotionReport';
import EmotionAlert from './EmotionAlert';
import LongTermMemory from './LongTermMemory';
import { RootState } from '@/store';

function MainArea() {
  const room = useSelector((state: RootState) => state.room);
  const { isInChatPage, currentCardView } = room;

  // 如果有卡片视图打开，显示对应的卡片页面
  if (currentCardView) {
    switch (currentCardView) {
      case 'emotion-report':
        return <EmotionReport />;
      case 'emotion-alert':
        return <EmotionAlert />;
      case 'long-term-memory':
        return <LongTermMemory />;
      default:
        return null;
    }
  }

  // 否则显示默认的页面（进入对话页面前/后）
  return isInChatPage ? <Room /> : <Antechamber />;
}

export default MainArea;
